import { TournamentSegment } from "model/Tournament/Segment/TournamentSegment";
import {
  getMatchemPriorMatchIds,
  MatchemDetails,
} from "model/PickemDetails/Matchem/Details";
import { selectMatches } from "selectors/Match";
import { MatchemMatchPicker } from "./MatchemMatchPicker";
import { Pick } from "model/Pickem/Pickem";
import { PickersContainer } from "../styles";
import { Panel } from "components/Panel/Panel";
import { Match } from "model/Match/Match";
import { useAppSelector } from "app/hooks";

interface Props {
  matchemDetails: MatchemDetails;
  tournamentSegment: TournamentSegment;
  matches: Match[];
  picks: {
    [id: string]: Pick;
  };
  updatePicks: (newPicks: { id: string; pick: Pick }[]) => void;
}

export const MatchemPicker = ({
  matchemDetails,
  tournamentSegment,
  matches,
  picks,
  updatePicks,
}: Props) => {
  const priorMatchIds =
    getMatchemPriorMatchIds(matchemDetails, tournamentSegment) ?? [];

  const priorMatches = useAppSelector((state) =>
    selectMatches(state, priorMatchIds)
  );

  const sortedMatches = matches.sort((a, b) => a.startTimeMs - b.startTimeMs);

  return (
    <Panel>
      <PickersContainer>
        {sortedMatches.map((match) => (
          <MatchemMatchPicker
            match={match}
            tournamentId={matchemDetails.tournamentId}
            priorMatches={priorMatches}
            currentPick={picks[match.id]}
            updatePick={(rosterId: string | undefined) =>
              updatePicks([{ id: match.id, pick: rosterId }])
            }
          />
        ))}
      </PickersContainer>
    </Panel>
  );
};
